import type { MediaType } from '@ooh/contracts';
import type { TFunction } from 'i18next';

// ─── Media type color map (REQ-6.2: visual distinction) ──────

export const mediaTypeColors: Record<MediaType, string> = {
  billboard: '#3b82f6',
  backlight: '#0ea5e9',
  citylight: '#22c55e',
  słup: '#4ade80',
  cityscroll: '#84cc16',
  konstrukcja: '#eab308',
  'wielki format': '#f97316',
  mural: '#ec4899',
  dooh: '#a855f7',
  inne: '#6b7280',
};

export function getMediaTypeLabel(type: MediaType, t: TFunction<'map'>): string {
  return t(`legend.types.${type}`);
}
